import { pageInfo, exportData} from './../api';
import { Message } from 'element-ui';
import { plant, supplierList } from '../../../../api'
const toxinInspectVehicleManual = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    updateResp: null,
    exportObj: [],
    supplierObj: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    UPDATE_DATA(state, data){
      state.updateResp = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    SUPPLIER_LIST(state, data) {
      state.supplierObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async supplierList({commit}, obj) {
      let resp = await supplierList(obj);
      commit('SUPPLIER_LIST', resp);
    }
  }
}
export default toxinInspectVehicleManual



// WEBPACK FOOTER //
// ./src/page/report/onSiteEfficiency/store/onSiteEfficiency.store.js